import { cn } from "@utils/tailwind-merge";
import clsx from "clsx";
import { ComponentPropsWithoutRef } from "react";
import LoaderIcon from "@assets/icon/loader.svg?react"
 


export interface SolidButtonProps extends ComponentPropsWithoutRef<"button"> {
  isLoading?: boolean
  /**
   * use custom to remove all default style value, so you define it's value with your style
   */
  variant?: "success" | "primary" | "warning" | "danger" | "base" | "custom" | "default";
}



export function SolidButton({variant = "primary", disabled, className,  ...props}: SolidButtonProps){
  return (
    <button
      className={cn(
        "px-12 py-0.5 rounded transition",
        variant === "primary" && !disabled && "bg-primary hover:bg-primary/80 active:bg-primary/70",
        variant === "success" && !disabled && "bg-success-dark hover:bg-success-dark/80 active:bg-success-dark/70",
        variant === "warning" && !disabled && "bg-warning hover:bg-warning/80 active:bg-warning/70 text-black",
        variant === "base" && !disabled && "bg-gray-600 hover:bg-gray-600/80 active:bg-gray/70 text-gray-300",
        variant === "danger" && !disabled && "bg-danger hover:bg-danger/80 active:bg-danger/70 text-white",

        variant === "primary" && disabled && "bg-primary/50",
        variant === "success" && disabled && "bg-success-dark/50",
        variant === "warning" && disabled && "bg-warning/50",
        variant === "danger" && (disabled || props.isLoading) && "bg-danger/50",
        variant === "base" && disabled && "bg-gray-600/50 text-gray-500",
        disabled && "cursor-not-allowed",
        props.isLoading && "cursor-not-allowed",
        className,
      )}
      disabled={disabled || props.isLoading}
      {...props}
    >
      {/* {props.children} */}
      <div className="flex justify-center gap-1 items-center">
        {props.isLoading && <LoaderIcon width={20} height={20} className="animate-spin" />}
        {props.children}
      </div>
    </button>
  )
}